/** Query key factory: one namespace per resource so mutations can invalidate precisely. */
export const qk = {
  me: () => ['me'] as const,
  company: () => ['company'] as const,
  dashboard: {
    all: () => ['dashboard'] as const,
    today: (date: string) => ['dashboard', 'today', date] as const,
    toDate: (jobId: string) => ['dashboard', 'to-date', jobId] as const,
  },
  jobs: {
    all: () => ['jobs'] as const,
    list: (filters: Record<string, string | undefined>) => ['jobs', 'list', filters] as const,
    detail: (id: string) => ['jobs', 'detail', id] as const,
  },
  costCodes: {
    all: () => ['cost-codes'] as const,
    list: (jobId: string) => ['cost-codes', jobId] as const,
  },
  users: {
    all: () => ['users'] as const,
    list: (filters: Record<string, string | undefined>) => ['users', 'list', filters] as const,
  },
  equipment: {
    all: () => ['equipment'] as const,
    list: (filters: Record<string, string | undefined>) => ['equipment', 'list', filters] as const,
  },
  entries: {
    all: () => ['entries'] as const,
    list: (filters: Record<string, string | undefined>) => ['entries', 'list', filters] as const,
    detail: (id: string) => ['entries', 'detail', id] as const,
  },
  quickbooks: {
    all: () => ['quickbooks'] as const,
    status: () => ['quickbooks', 'status'] as const,
    candidates: () => ['quickbooks', 'candidates'] as const,
    logs: () => ['quickbooks', 'logs'] as const,
    preview: (scope: Record<string, string | undefined>) =>
      ['quickbooks', 'preview', scope] as const,
  },
  exports: {
    detail: (id: string) => ['exports', id] as const,
  },
};
